import { NAMED_CACHE_NAME } from "@/shared/utils/sw/sw.constants";
import { selectorNamedCacheKeysAvailable } from "@/shared/store/sw/selectorNamedCacheKeysAvailable";

export const selectorWaveformsDownloadedIds = (state) => {
  return selectorNamedCacheKeysAvailable(state)[NAMED_CACHE_NAME.WAVEFORM];
};